import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-page404",
  templateUrl: "./page404.component.html",
  styleUrls: ["./page404.component.scss"],
})

/**
 * PAges-404 component
 */
export class Page404Component implements OnInit {
  constructor(
    private translate: TranslateService,
    private cookieService: CookieService
  ) {
    this.translate.addLangs(["pt-br", "es"]);
    this.translate.setDefaultLang("pt-br");
    this.translate.use(this.cookieService.get("lang"));
  }

  ngOnInit(): void {}
}
